import Card from './card'

const ContactGrid = ({ forms, setUser }) => {
  return (
    <div data-gt-componentname="type-grid">
      <div className="flex flex-wrap mb-2 -mx-2 justify-center">
        {Object.keys(forms).map((form) => {
          return <Card key={form} form={forms[form]} setUser={setUser} />
        })}
      </div>
    </div>
  )
}

export default ContactGrid
